<div class="resolve">
  <div class="header" [class.kuititon]="kortti.tyyppi === 'kuititon'">
    @if (kortti.tyyppi !== 'kuititon') {
      @if (esikatselukuvaUrl()) {
        <button class="thumb thumb-avattava" type="button" (click)="avaaKuva()" [attr.aria-label]="'tositteet.selvitys.nayta-kuva-suurempana' | translate | async">
          <div app-tosite-kuva [url]="esikatselukuvaUrl()" [thumbnail]="true" class="thumb-kuva"></div>
          <span class="zoom-vihje" aria-hidden="true"><span class="material-symbols-outlined">zoom_in</span></span>
        </button>
      } @else {
        <div class="thumb">
          <div class="thumb-inner"><span></span><span></span><span></span><span></span><span></span><span></span></div>
        </div>
      }
    } @else {
      <div class="thumb thumb-question">
        <span class="material-symbols-outlined">help_outline</span>
      </div>
    }

    <div>
      <div class="supplier">{{ kortti.maksunsaaja || kortti.viesti }}</div>
      <div class="date">{{ kortti.pvml | lokaalipvm | async }}</div>
      @if (kortti.kirjauksenViesti && (kortti.maksunsaaja || kortti.kirjauksenViesti !== kortti.viesti)) {
        <div class="kirjauksen-viesti">{{ kortti.kirjauksenViesti }}</div>
      }
    </div>

    <div class="amount">{{ kortti.summa | lmoney | async }}</div>
  </div>

  <div class="divider"></div>

  @if (kortti.tyyppi !== 'kuititon') {
    <span class="chip">
      <span class="material-symbols-outlined chip-icon">info</span>
      {{ 'tositteet.selvitys.tarvitaan-lisatietoja' | translate | async }}
    </span>
    <div class="question">{{ kortti.kysymys }}</div>
    <textarea class="textarea" [formField]="vastaus" rows="2" [attr.aria-label]="'tositteet.vastaus-selvityspyyntoon' | translate | async"></textarea>
    <div class="actions">
      <button class="btn btn-primary" type="button" (click)="tallennaVastaus()" [class.onnistui-btn]="tallennustila() === 'tallennettu'" [disabled]="vastausPituus === 0 || tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.tallenna' | translate | async">
        @if (tallennustila() === 'lomake') {
          <span class="material-symbols-outlined btn-icon" aria-hidden="true">check</span>
        } @else {
          <span class="spinner" aria-hidden="true"></span>
        }
        {{ 'tositteet.selvitys.tallenna' | translate | async }}
      </button>
      @if (kortti.tositeAvaimet?.length > 0) {
        <button class="btn btn-ghost btn-icon-only" type="button" (click)="avaaTositteenMuokkaus()" [attr.aria-label]="'tositteet.selvitys.avaa-muokkausnakyma' | translate | async">
          <span class="material-symbols-outlined btn-icon" aria-hidden="true">edit</span>
        </button>
      }
    </div>
  } @else {
    <span class="chip">
      <span class="material-symbols-outlined chip-icon">info</span>
      {{ 'tositteet.selvitys.tosite-puuttuu' | translate | async }}
    </span>
    <div class="question">{{ kortti.kysymys }}</div>
    @if (!muuKasittelyAuki) {
      <div class="actions">
        <button class="btn btn-primary btn-left" type="button" (click)="avaaTositteenLisays()" [attr.aria-label]="'tositteet.selvitys.lisaa-tosite' | translate | async">
          <span class="material-symbols-outlined btn-icon" aria-hidden="true">add</span>
          {{ 'tositteet.selvitys.lisaa-tosite' | translate | async }}
        </button>
        <input #tositeInput type="file" multiple accept="image/*,.pdf,.heic" style="display: none" (change)="tositeTiedostotMuuttui($event)" [attr.aria-label]="'tositteet.selvitys.lisaa-tosite' | translate | async" />
        <button class="btn btn-ghost" type="button" (click)="muuKasittelyAuki = true" [attr.aria-label]="'tositteet.selvitys.muu-kasittely' | translate | async">
          {{ 'tositteet.selvitys.muu-kasittely' | translate | async }}
        </button>
      </div>
    } @else if (hukkunutAuki) {
      <button class="takaisin" type="button" (click)="hukkunutAuki = false" [disabled]="tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.takaisin' | translate | async">
        <span class="material-symbols-outlined takaisin-icon" aria-hidden="true">chevron_left</span>
        {{ 'tositteet.selvitys.takaisin' | translate | async }}
      </button>
      <div class="tarkennus-otsikko">{{ 'tositteet.selvitys.tosite-hukkunut' | translate | async }}</div>
      <div class="tarkennus-kuvaus">{{ 'tositteet.selvitys.kerro-mita-ostettiin' | translate | async }}</div>
      <textarea class="textarea" [formField]="hukkunutSelite" rows="3" [placeholder]="'tositteet.selvitys.hukkunut-esimerkki' | translate | async" [attr.aria-label]="'tositteet.selvitys.kerro-mita-ostettiin' | translate | async"></textarea>
      <div class="actions">
        <button class="btn btn-primary" type="button" (click)="tallennaHukkunut()" [class.onnistui-btn]="tallennustila() === 'tallennettu'" [disabled]="hukkunutSelitePituus === 0 || tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async">
          @if (tallennustila() === 'lomake') {
            <span class="material-symbols-outlined btn-icon" aria-hidden="true">check</span>
          } @else {
            <span class="spinner" aria-hidden="true"></span>
          }
          {{ 'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async }}
        </button>
      </div>
    } @else if (omaHankintaAuki) {
      <button class="takaisin" type="button" (click)="omaHankintaAuki = false" [disabled]="tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.takaisin' | translate | async">
        <span class="material-symbols-outlined takaisin-icon" aria-hidden="true">chevron_left</span>
        {{ 'tositteet.selvitys.takaisin' | translate | async }}
      </button>
      <div class="tarkennus-otsikko">{{ 'tositteet.selvitys.oma-hankinta' | translate | async }}</div>
      <div class="tarkennus-kuvaus">{{ 'tositteet.selvitys.kenelle-velka-kirjataan' | translate | async }}</div>
      <input class="tekstikentta" type="text" [formField]="velallinen" (keyup.enter)="tallennaOmaHankinta()" [placeholder]="'tositteet.selvitys.velallinen-vihje' | translate | async" [attr.aria-label]="'tositteet.selvitys.kenelle-velka-kirjataan' | translate | async" />
      <div class="actions">
        <button class="btn btn-primary" type="button" (click)="tallennaOmaHankinta()" [class.onnistui-btn]="tallennustila() === 'tallennettu'" [disabled]="velallinenPituus === 0 || tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async">
          @if (tallennustila() === 'lomake') {
            <span class="material-symbols-outlined btn-icon" aria-hidden="true">check</span>
          } @else {
            <span class="spinner" aria-hidden="true"></span>
          }
          {{ 'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async }}
        </button>
      </div>
    } @else if (eiTositettaAuki) {
      <button class="takaisin" type="button" (click)="eiTositettaAuki = false" [disabled]="tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.takaisin' | translate | async">
        <span class="material-symbols-outlined takaisin-icon" aria-hidden="true">chevron_left</span>
        {{ 'tositteet.selvitys.takaisin' | translate | async }}
      </button>
      <div class="tarkennus-otsikko">{{ 'tositteet.selvitys.ei-tositetta' | translate | async }}</div>
      <div class="tarkennus-kuvaus">{{ 'tositteet.selvitys.ei-tositetta-varmistus' | translate | async }}</div>
      <div class="actions">
        <button class="btn btn-primary" type="button" (click)="tallennaEiTositetta()" [class.onnistui-btn]="tallennustila() === 'tallennettu'" [disabled]="tallennustila() !== 'lomake'" [attr.aria-label]="'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async">
          @if (tallennustila() === 'lomake') {
            <span class="material-symbols-outlined btn-icon" aria-hidden="true">check</span>
          } @else {
            <span class="spinner" aria-hidden="true"></span>
          }
          {{ 'tositteet.selvitys.laheta-kirjanpitajalle' | translate | async }}
        </button>
      </div>
    } @else {
      <div class="kasittely-valinnat">
        @if (yritysmuoto === TOIMINIMI) {
          <button class="kasittely-vaihtoehto" type="button" [class.onnistui]="valittuKasittelytapaAvain === 'tositteet.selvitys.yksityisotto'" (click)="valitseKasittelytapa('tositteet.selvitys.yksityisotto')" [disabled]="tallennustila() !== 'lomake'">
            <div class="kasittely-otsikko">{{ 'tositteet.selvitys.yksityisotto' | translate | async }}</div>
            <div class="kasittely-kuvaus">{{ 'tositteet.selvitys.yksityisotto-kuvaus' | translate | async }}</div>
            @if (tallennustila() !== 'lomake' && valittuKasittelytapaAvain === 'tositteet.selvitys.yksityisotto') {
              <span class="spinner spinner-dark" aria-hidden="true"></span>
            }
          </button>
        } @else {
          <button class="kasittely-vaihtoehto" type="button" (click)="omaHankintaAuki = true" [disabled]="tallennustila() !== 'lomake'">
            <div class="kasittely-otsikko">{{ 'tositteet.selvitys.oma-hankinta' | translate | async }}</div>
            <div class="kasittely-kuvaus">{{ 'tositteet.selvitys.oma-hankinta-kuvaus' | translate | async }}</div>
          </button>
        }
        <button class="kasittely-vaihtoehto" type="button" (click)="hukkunutAuki = true" [disabled]="tallennustila() !== 'lomake'">
          <div class="kasittely-otsikko">{{ 'tositteet.selvitys.tosite-hukkunut' | translate | async }}</div>
          <div class="kasittely-kuvaus">{{ 'tositteet.selvitys.tosite-hukkunut-kuvaus' | translate | async }}</div>
        </button>
        <button class="kasittely-vaihtoehto" type="button" (click)="eiTositettaAuki = true" [disabled]="tallennustila() !== 'lomake'">
          <div class="kasittely-otsikko">{{ 'tositteet.selvitys.ei-tositetta' | translate | async }}</div>
          <div class="kasittely-kuvaus">{{ 'tositteet.selvitys.ei-tositetta-kuvaus' | translate | async }}</div>
        </button>
      </div>
      <button class="btn btn-ghost" type="button" (click)="muuKasittelyAuki = false" [attr.aria-label]="'tositteet.selvitys.peruuta' | translate | async">
        {{ 'tositteet.selvitys.peruuta' | translate | async }}
      </button>
    }
  }

  @if (virheAvain()) {
    <div class="virhe error-text" role="alert">{{ virheAvain() | translate | async }}</div>
  }
</div>

@if (kuvaAuki) {
  <div class="kuva-modal" role="dialog" aria-modal="true" (click)="suljeKuva()">
    <button class="kuva-modal-sulje" type="button" (click)="suljeKuva()" [attr.aria-label]="'tositteet.selvitys.sulje-kuva' | translate | async">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
    <div class="kuva-modal-sivut">
      @for (url of kuvaUrlit(); track url) {
        <div app-tosite-kuva class="kuva-modal-sivu" [url]="url" (click)="$event.stopPropagation()"></div>
      }
    </div>
  </div>
}
